module.exports = __webpack_public_path__ + "assets/calendar.2fb7bd2b.svg";